import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IRootState } from './reducers';
import i18n from './resources/i18n';
import CommonScenarioFactory, { ILogError } from './scenario/common';

interface IState {
	hasError: boolean;
}

class ErrorHandler extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			hasError: false,
		};
	}

	public componentDidCatch(e: Error, info: React.ErrorInfo) {
		const args: ILogError = { e, info };
		this.props.logError(this.props.token, args);
		this.setState({
			hasError: true,
		});
	}

	public render() {
		if (this.state.hasError) {
			return <div>{i18n.t('ErrorHandler_0001')}</div>;
		}
		return <div>{this.props.children}</div>;
	}
}

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	logError: (token: string, args: ILogError) => {
		const scenario = CommonScenarioFactory.createLogError(token);
		scenario.run(args);
	},
});

// tslint:disable-next-line: no-empty-interface
export interface IErrorHandlerProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = IErrorHandlerProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ErrorHandler);

export default Connected;



// WEBPACK FOOTER //
// ./src/ErrorHandler.tsx